<template>
  <div class="billboard">
    <div v-for="(column,columnIndex) in billboardData" :key="column.uuid" :ref="`column${columnIndex}`" class="column">
      <div class="content">
        <!--顶部标题-->
        <div class="top-title">
          <span>{{column.label}}({{column.value.length}})</span>
          <i @click.stop="addCard(column,columnIndex)" class="top-add el-icon-plus"></i>
        </div>
        <!--拖拽内容-->
        <div class="draggable-list" :style="{maxHeight: height+'px'}">
          <draggable
            v-model="column.value"
            @add="addItem($event,columnIndex)"
            @remove="removeItem($event,columnIndex)"
            @update="dragUpdate($event,columnIndex)"
            :options="options">
            <transition-group>
              <li class="childModule" :class="active.columnIndex===columnIndex&&active.cardIndex===cardIndex?'activeCard':''"
                  @dblclick.stop="deleteCard('edit',column,item,cardIndex)"
                  @click.stop="cardClick(columnIndex,cardIndex)" :key="item.Id" v-for="(item,cardIndex) in column.value">
                {{item[billboardProperties.showReportColumnId]}}
                <el-dropdown v-if="isRuntime" trigger="click"  @command="type => deleteCard(type,column,item,cardIndex,columnIndex)" class="little-point">
                  <i v-show="active.columnIndex===columnIndex&&active.cardIndex===cardIndex" class="el-icon-more"></i>
                  <el-dropdown-menu slot="dropdown" class="dropdown-list">
                    <el-dropdown-item command="edit">编辑</el-dropdown-item>
                    <el-dropdown-item command="copy">复制</el-dropdown-item>
                    <el-dropdown-item command="delete">删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </li>
              <li class="childModule" :key="-1" v-show="column.value.length===0">&nbsp;</li>
            </transition-group>
          </draggable>
        </div>
        <!--底部添加-->
        <div @click.stop="addCard(column,columnIndex)" class="bottom-add"><i class="el-icon-plus"></i>添加新项</div>
      </div>
    </div>
    <!--添加新项-->
    <el-dialog title="添加新项" top="34vh" :modal-append-to-body="false" :modal="false" :visible.sync="dialogVisible" class="addModel" width="30%">
      <el-input ref="newCardInput" type="textarea" :rows="4" v-model="newCardData.newCardText" resize="none"></el-input>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" type="primary" @click="addNewCard">保 存</el-button>
          <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
export default {
  name: 'billboard',
  props: {
    billboardData: {
      type: Array,
      default: () => []
    },
    isRuntime: {
      type: Boolean,
      default: false
    },
    billboardProperties: {
      type: Object,
      default: () => {
        return {
          classificationColumnId: '',
          classificationTableId: '',
          mainTableId: '',
          showColumnId: '',
          showColumnTableId: ''
        }
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    Draggable
  },
  data () {
    return {
      active: {
        columnIndex: '',
        cardIndex: ''
      },
      dialogVisible: false,
      newCardData: {
        newCardText: '',
        columnIndex: '',
        column: ''
      },
      options: {
        sort: this.isRuntime,
        group: 'billboard'
      },
      newColumnIndex: null,
      height: 0
    }
  },
  mounted () {
    this.seHeight()
  },
  methods: {
    seHeight () {
      this.$nextTick(() => {
        this.height = this.isRuntime ? this.$refs.column0[0].offsetHeight - 96 : document.querySelector('.billboard-map').offsetHeight - 96
      })
    },
    getColumnData (index) {
      //  更新拖拽的数据，并获取走接口所用更新完的数据
      let numberReportColumnId = this.billboardProperties.numberReportColumnId
      let arr = []
      this.billboardData[index].value.forEach((n, index) => {
        n[numberReportColumnId] = index
        let obj = {}
        obj['id'] = n.Id
        obj[this.billboardProperties.numberColumnId] = n[this.billboardProperties.numberReportColumnId]
        arr.push(obj)
      })
      return arr
    },
    dragUpdate (event, index) {
      //  只有同列更新时才会触发。换行拖拽不会
      if (event.item.classList.contains('activeCard')) {
        //  列内元素拖拽，列下标固定
        this.active.cardIndex = event.newIndex
      }
      //  更新当前列的数据
      let arr = this.getColumnData(index)
      //  更新列数据
      this.updateData(arr)
    },
    updateData (arr) {
      return this.$axios.post(`/report-api/report/data/saveKanBanData/${this.id}`, arr)
    },
    addItem (event, index) {
      this.newColumnIndex = index
    },
    removeItem (event, index) {
      //  原来列的index
      let oldColumnIndex = index
      //  当前列的index
      let newColumnIndex = this.newColumnIndex
      //  换行后下标
      let newIndex = event.newIndex
      //  获取2个数组。并concat后走接口更新数据
      let beforeColumnArr = this.getColumnData(oldColumnIndex)
      let afterColumnArr = this.getColumnData(newColumnIndex)
      //  更新换行内容中的分类列的值
      let labelColumnId = this.billboardData[newColumnIndex].labelColumnId
      let key = this.billboardData[newColumnIndex].key
      let label = this.billboardData[newColumnIndex].label
      let classificationColumnId = this.billboardProperties.classificationColumnId
      //  直接拖拽同时跟空模块换位后，会出现newIndex为1，但空模块去除了。应为0
      if (newIndex === 1 && afterColumnArr.length === 1) {
        newIndex = 0
      }
      if (labelColumnId) {
        //  有数据源
        afterColumnArr[newIndex][labelColumnId] = key
        afterColumnArr[newIndex][classificationColumnId] = label
      } else {
        // 没有数据源
        afterColumnArr[newIndex][classificationColumnId] = label
      }
      let arr = [].concat(beforeColumnArr, afterColumnArr)
      this.updateData(arr)
    },
    addCard (column, columnIndex) {
      if (this.isRuntime) {
        //  弹窗。设置值
        this.newCardData.newCardText = ''
        this.newCardData.column = column
        this.newCardData.columnIndex = columnIndex
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.newCardInput.$el.querySelector('textarea').focus()
        })
      }
    },
    cardClick (columnIndex, cardIndex) {
      if (this.isRuntime) {
        this.active.columnIndex = columnIndex
        this.active.cardIndex = cardIndex
      }
    },
    deleteCard (type, column, card, cardIndex, columnIndex) {
      if (type === 'delete') {
        //  走接口删除当前行
        //  再物理删除当前行
        this.$axios.delete(`/data-api/data/${this.billboardProperties.showColumnTableId}/${card.Id}`).then(() => {
          column.value.splice(cardIndex, 1)
          this.active.columnIndex = ''
          this.active.cardIndex = ''
        })
      } else if (type === 'copy') {
        //  给当前新增数据
        this.newCardData.column = column
        this.newCardData.newCardText = card[this.billboardProperties.showReportColumnId]
        this.newCardData.columnIndex = columnIndex
        this.addNewCard()
      } else if (type === 'edit') {
        this.$emit('edit', card)
      }
    },
    addNewCard () {
      //  新增
      this.dialogVisible = false
      //  获取当前列现有数据
      let arr = this.getColumnData(this.newCardData.columnIndex)
      //  插入新数据，并整体更新
      let obj = {}
      let labelColumnId = this.newCardData.column.labelColumnId
      let key = this.newCardData.column.key
      let label = this.newCardData.column.label
      let content = this.newCardData.newCardText
      let classificationColumnId = this.billboardProperties.classificationColumnId
      if (labelColumnId) {
        //  有数据源
        obj[labelColumnId] = key
        obj[classificationColumnId] = label
      } else {
        // 没有数据源
        obj[classificationColumnId] = label
      }
      obj[this.billboardProperties.showColumnId] = content
      obj[this.billboardProperties.numberColumnId] = arr.length
      arr.push(obj)
      this.$parent.loading = true
      this.updateData(arr).then(() => {
        this.$emit('search')
      })
    }
  },
  watch: {
    $route (newVal, oldVal) {
      newVal.path.includes(this.id) && this.seHeight()
    }
  }
}
</script>

<style lang="scss">
  .billboard{
    display: flex;
    padding-bottom: 20px;
    background-color: #fff;
    .column{
      width: 320px;
      min-width: 320px;
      margin-right: 15px;
      height: 100%;
      overflow: hidden;
      background-color: #ffffff;
      box-sizing: border-box;
      .content{
        border: 1px solid #f9f9f9;
        border-radius: 5px;
        box-shadow:0 3px 2px 2px #fafafa;
        background-color: #ffffff;
        max-height: 100%;
      }
      .top-title{
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        font-family: "Microsoft YaHei UI";
        color: #323232;
        border-bottom: 1px solid #EBEBEB;
        padding: 0 10px;
        margin-bottom: 10px;
        .top-add{
          color: #C2C3C4;
        }
        .top-add:hover{
          color: #55ACF1;
        }
        .top-add:active{
          color: #449be0;
        }
      }
      .draggable-list{
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0 10px;
      }
      .childModule{
        padding: 15px 10px;
        background-color: #F6F7F7;
        color: #333;
        margin: 0 auto;
        margin-bottom: 10px;
        width: 300px;
        position: relative;
        border: 1px solid #F6F7F7;
        border-radius: 3px;
        .little-point{
          position: absolute;
          right: 8px;
          top: 0;
          display: flex;
          width: 14px;
          height: 14px;
        }
        .el-icon-more{
          color:#a2a3a4;
        }
        .el-icon-more:active{
          color: #439Ae0;
        }
        .el-icon-more:hover{
          color:#54ABF1;
        }
      }
      .childModule:hover{
        background-color: #F0F7FC;
        .el-icon-more{
          display: block!important;
        }
      }
      .activeCard {
        background-color: #F0F7FC;
        border: 1px solid #54ABF1;
      }

      .childModule:nth-last-child(2) {
        margin-bottom: 0;
      }
      .childModule:last-child {
        margin-bottom: 0;
      }
      .bottom-add{
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-family:"Microsoft YaHei UI";
        font-size: 12px;
        color: #a2a3a4;
        cursor: default;
      }
      .bottom-add:hover{
        color: #55ACF1;
      }
      .bottom-add:active{
        color: #449be0;
      }
    }
    .column:nth-child(5n+1){
      border-top: 2px solid #54ABF1;
      border-top-right-radius:0;
      border-top-left-radius:0;
    }
    .column:nth-child(5n+2){
      border-top: 2px solid #F18854;
      border-top-right-radius:0;
      border-top-left-radius:0;
    }
    .column:nth-child(5n+3){
      border-top: 2px solid #FF5589;
      border-top-right-radius:0;
      border-top-left-radius:0;
    }
    .column:nth-child(5n+4){
      border-top: 2px solid #BC53C8;
      border-top-right-radius:0;
      border-top-left-radius:0;
    }
    .column:nth-child(5n+5){
      border-top: 2px solid #36A011;
      border-top-right-radius:0;
      border-top-left-radius:0;
    }
    .addModel{
      .el-dialog__body{
        padding: 20px;
        .el-textarea{
          margin-top: 10px;
        }
      }
      .el-dialog__footer{
        text-align: center;
      }
    }
  }
  .dropdown-list[x-placement^=bottom]{
    margin-top: 0;
    margin-right: -30px;
    .popper__arrow{
      display: none;
    }
  }
  .dropdown-list{
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/report/design/customPage/billboard.vue